export default __webpack_public_path__ + "static/media/certification-procedure.141d25ae.png";